/**
 * 公共字段
 */

export const PAGE_HEADER_TITLE = {
  index: "知书",
  sayingBook: "讲书",
  startCourse: "开课",
  audioBook: "有声书",
  eBook: "电子书",
  ebookCatalogList: "电子书分类",
  videoList: "视频",
  search: "搜寻",
  searchCatalog: "分类搜寻",
  detail: "详情",
  audioDetail: "播放详情",
  videoDetail: "视频详情",
  login: "登入",
  bindEmail: "绑定电邮",
  forget: "忘记密码",
  register: "注册",
  nickName: "设置称谓",
  registerSuccess: "注册成功",
  buy: "注册成功",
  buySuccess: "购买成功",
  recharge: "增值",
  rechargeTips: "付款提示",
  andRecharge: "支付",
  rechargeList: "增值记录",
  rechargeSuccess: "增值成功",
  purchase: "已购",
  personal: "个人资料",
  bindPhone: "绑定手机",
  collection: "收藏",
  historyRecordAudio: "听过的书",
  historyRecordEbook: "看过的书",
  historyRecordCourse: "听过的课",
  coupon: "优惠券",
  exchange: "兑换优惠券",
  exchangez: '礼品卡充值',
  setting: "设置",
  about: "关于",
  feedback: "反馈",
  vip: "会员",
  ebookGuide: "电子书",
  ebookDetail: "电子书",
  comment: "留言",
  help: "帮助中心",
  advertising: "广告合作",
  useTerms: '使用条款',
  policy: '隐私政策',
  memberArea: '会员专区',
  expensesRecord: "消费记录",
  recordDetails: "消费详情",
  memberInfo: "会员",
  vipDetails: "会籍详情",
  supremeMember: "至尊会员",
  discount: "专享折扣",
  freeGoods: "专享免费",
  memberGift: "会员礼包",
  vipDetails2: "会籍详情",
  signCalendar: "签到",
  signDescription: "签到规则",
  signGifts: "签到礼包",
  flashSalesList: "限时闪购",
  recommendSalesList: "精品推荐",
  giftPackDetail: "活动礼包",
  activityList: "促销活动",
  news: "消息",
  epubLocalList: '离线阅读',
  testTile: '测一测',
  audioTest: '测一测'
}

export const MENU_LANG = {
  menu: ['讲书', '开课', '有声书', '电子书', '视频', '查看详情']
}
export const SPEAKER_LANG = '讲者'
export const AUTHOR_LANG = '作者'
export const PRICE_UNIT_LANG = '知书币'
export const FREE_LANG = '免费'
export const DETAILS_LANG = "详情"
export const MORE_LANG = "更多"
export const COURSE_LANG = {
  course: {
    preview: '试听',
    read: '试阅',
    immediatelyRead: '立即阅读',
    courseCount: ['共', '课时', '集'],
    isBuy: '已购买',
    buy: '购买'
  }
}


/**
 * 公共提示字段
 */

export const REQUEST_ERR_LANG_1 = '请求失败'
export const REQUEST_ERR_LANG_2 = '获取用户信息失败'
export const REQUEST_ERR_LANG_3 = '加载数据失败'
export const REQUEST_ERR_LANG_4 = '缺少参数'
export const REQUEST_ERR_LANG_5 = '请求失败,请稍候再试'
export const REQUEST_ERR_LANG_6 = '数据出错,请稍后再试'
export const REQUEST_ERR_LANG_7 = '系统出错,请稍后再试'
export const PLAYADDRESS_ERR_LANG = '获取播放地址失败'

export const receive_btn = '立即领取'



// 首頁
export const INDEX_LANG = {
  topTitle: "知书",
  menu: ['讲书', '开课', '有声书', '电子书', '视频'],
  search: {
    placeholder: '搜索',
    title: '必须输入'
  },
  talkbook: {
    title: '名家讲书',
  },
  course: {
    title: '精品课程',
    courseCount: ['共', '课时'],
    isBuy: '已购买'
  },
  audioBook: {
    title: '有声阅读'
  },
  video: {
    title: '免费赏'
  },
  ebook: {
    title: '电子书'
  },
  vipCar: {
    carTitle: '知书会员卡',
    title: '知书会员'
  },

  content: {
    title: "新手大礼包",
    description: "恭喜获得新手大礼包",
    content: "（优惠券、送币、免费内容）"
  },
  umengObj: "首页",
  userDo: ["观看", "聆听"],
  backHome: "返回首页"
}


//講書列表頁
export const SAYINGBOOK_LANG = {
  listTitle: ['最新', '名家', 'AI导读', '推荐'],
  page: ["讲书", "讲书栏目页"]
}

//開課列表頁
export const STARTCOURSE_LANG = {
  // listTitle: ['精品课', '大师课', '生活', '学经典', '技能', '公开课']
  listTitle: ['精品课', '大师课', '生活课', '学经典', '职场课', '公开课'],
  page: "开课"
}

//聲書列表頁
export const AUDIOBOOK_LANG = {
  listTitle: ['最新', '推荐', 'AI快读', '儿童', '吟诵', '经典'],
  page: "有声书",

}

//電子書列表頁
export const EBOOK_LANG = {
  topTitle: "电子书",
  listTitle: ['香港专题', '精选', '倪匡专区', '类型小说', '亲子', '世界名著'],
  page: [
    "电子书",
    "有声书栏目页",
    "分类"
  ]
}

//電子書分類頁
export const EBOOKLIST_LANG = {
  topTitle: "电子书分类",
  book: '图书',
  ce: "册",
  none: "暂无内容"
}

//電子書引導頁
export const EBOOKGUIDE_LANG = {
  text: ["会员免费阅读", "活动免费领取", "会员免费领取"]
}

//視頻列表页
export const VIDEOLIST_LANG = {
  listTitle: ['访谈', '导赏', '写经典'],
  video: "视频"
}

//買書頁
export const BUYBOOK_LANG = {
  name: '《果杀中宇宙》',
  btnText: '购买即可阅读完全文'
}

//電子書詳情頁
export const EBOOKDETAIL_LANG = {
  columnName: '电子书',
  read: '试阅',
  column: "栏目",
  limitedTimeShopping: "限时闪购",
  limitedTimeShoppings: "限时闪购价",
  freeForMembers: "会员免费",
  umengText: [
    "我听过的书",
    "我读过的书",
    "我学过的课程",
  ],
  paperBook: [
    "讲书",
    "开课",
    "有声书",
    "电子书",
    "视频",
    "查看详情",
  ],
  description: "详情页",
}

// 專欄頁面
export const DETAIL_LANG = {
  buyNumber: '人已购买',
  previewNumber: '人已聆听',
  buyBook: '购书',
  commentTitle: '留言',
  preview: '试听'
}

// 目錄組件
export const CATALOG_LANG = {
  title: '目录',
  audioNumber: '个音频',
  dialogMessage: '该内容需要购买才可播放',
  confirmText: '立刻购买',
  noPreview: '本专辑不支持试阅',
  text: ["个视频", "个音频"]
}

//評論組件
export const COMMENT_LANG = {
  comment: '评论',
  noComment: '暂无留言',
  delectText: '删除',
  reply: '回复',
  dialogMessage: '是否删除该评论',
  confirmText: '确定',
  textareaText: '请输入内容',
  showToastNull: '请填写留言内容',
  showToastSuccess: '留言成功',
  showToastFail: '留言失败',
  cancelLike: '已取消点赞',
  likeSuccess: '点赞成功'
}

//buyBar 組件
export const BUYBAR_LANG = {
  buy: "立刻购买",
  currency: '个币',
  speak: '讲',
  buySuccess: '购买成功',
}

//forget 忘记密码頁面
export const FORGET_LANG = {
  email: '邮箱',
  inputEmail: '请输入邮箱',
  code: '验证码',
  inputCode: '请输入验证码',
  second: '秒可重发',
  getCode: '获取验证码',
  pass: '新密码',
  inputPass: '请输入你的新密码',
  inputPassTwo: '请再次输入你的新密码',
  inputPassThree: '請輸入密碼',
  inputPassFour: '請再次輸入密碼',
  passMessage: '密码必须为英文与数字组合',
  confirm: '确认',
  confirmPass: '确认密码',
  emailNullErr: '请输入邮箱地址',
  emailErr: '邮箱地址格式不正确',
  sendCode: '验证码已经发送到你邮箱,请注意查收',
  getCodeErr: '获取验证码错误',
  CodeErr: '验证码格式不正确',
  twoPassErr: '两次输入不一致',
  resetPassSuccess: '重置密码成功',
  resetPassFail: '重置密码失败',
}

//login 登录頁面
export const LOGIN_LANG = {
  inputYouEmail: '请输入你的邮箱',
  email: '邮箱',
  inputYouPass: '请输入密码',
  pass: '密码',
  forGetPass: '忘记密码',
  phoneLogin: '使用手机号码注册/登录',
  youPhone: '请输入你的手机号码',
  phone: '手机',
  code: '验证码',
  second: '秒可重发',
  getCode: '获取验证码',
  emailLogin: '邮箱登录/注册',
  doLogin: '立即登录',
  doLoginTwo: '登录',
  reg: '注册',
  thirdLogin: '第三方注册登录',
  userSee: ['如要继续即表示您同意并接受「知书」的', '私隐声明', '及', '使用条款和细则'],
  newUserSee: "《知书隐私条款》",
  newUserSeeRule: ["66666本人已阅读并同意知书之", "隐私条款", "本人希望接收知书的最新资讯及优惠"],
  newUserSeeToast: "请先勾选隐私条款",
  area: ['中国大陆 +86', '香港(中国) +852', '澳门(中国) +853'],
  allowSuccess: '授权成功，需要绑定邮箱，即将跳转',
  allowSuccessTwo: '授权成功，即将跳转',
  allowSuccessThree: '授权成功',
  allow: '请求授权中',
  err: '失败',
  phoneNull: '手机号码不能为空',
  phoneErr: '请输入正确的手机号码',
  sendCodeSuccess: '验证码发送成功',
  sendCodeErr: '验证码获取失败',
  inputCode: '请输入验证码',
  codeErr: '请输入四位数验证码',
  loginErr: '登录失败',
  emailNullErr: '请输入邮箱地址',
  emailErr: '邮箱格式不正确',
  soFast: "发送频率太快，稍后再试",
}

//register 注册页
export const REGISTER_LANG = {

  inputYouPass: '请输入你的密码',
  inputYouPassTwo: '请再次输入你的密码',
  appellation: '昵称',
  inputAppellation: '请输入你的昵称',
  appellationMessage: '由2-12个中英文字母、数字 、 “-” 、“_” 组成',
  inputAppellationTwo: '请输入昵称',
  appellationMinLength: '请输入两个以上字符',
  appellationMaxLength: '请输入的字符超过12个',
  appellationErr: '昵称包含特殊字符',
  regSuccess: '注册成功',
  regFail: '注册失败',
}


//注册成功页
export const REGISTER_SUCCESS_LANG = {
  regSuccess: '注册成功!',
  text: [
    '恭喜成为知书会员',
    '尽享会员专有优惠,敬请关注',
    '知书会员',
  ],
  modify: '稍后修改',
  modifyData: '修改个人资料',
  getUserDataErr: '获取用户信息失败',
  isNotice: "本人希望获取知书的最新通讯及优惠",
  btnText: "确定",
  popText: "是否不再接受最新通讯及优惠公告"
}

//搜索页
export const SEARCH_LANG = {
  topTitle: "搜寻",
  inputTexas: '请输入要搜索的词语(不少于两个字)',
  search: '搜索',
  heatSearch: '热搜:',
  searchMessage: '暂无搜索内容',
  searchErr: '搜索关键词失败,请重试'
}

//分類搜尋
export const SEARCHCATALOG_LANG = {
  topTitle: "分类搜寻",
}

// purchase 页
export const PURCHASE_LANG = {
  menu: ['讲书', '课程', '有声书', '电子书'],
  readBook: [
    '个音频', '已听', '未听', '已听完'
  ],
  course: [
    '节课', '已听', '未听', '已听完'
  ],
  audioBook: [
    '作者', '朗读', '最近更新', '音频', '已听', '未听', '已听完'
  ],
  eBook: [
    '已读至', '未观看'
  ],
  loginState: [
    '登录后同步已购内容',
    '去登录'
  ]
}

// list 组件
export const LIST_LANG = {
  title: '还没有任何内容',
  buyTitle: '还没有购买任何内容',
  btnText: '去发现',
  surplus: "剩余",
  soldOut: "已售罄",
  buyAtOnce: "立刻购买",
  isBuy: "已购买"
}

// me页
export const ME_LANG = {
  goToLogin: '去登录',
  learningTime: '学习时间',
  getLearningTime: '获取用户学习时间失败',
  afterLoginShow: '登录后显示',
  readBook: '看过的书',
  hearCourse: '听过的课',
  hearBook: '听过的书',
  member: '知书会员',
  dowmLocal: '离线阅读',
  level: [
    // '基本会员',
    '知书会员',
    '折扣会员',
    '超级会员',
    '至尊会员',
  ],
  coupon: "优惠券",
  recordsOfConsumption: "消费记录"
}

// 邮箱绑定
export const BINDEMAIL_LENG = {
  bindSuccess: '邮箱绑定成功',
  bindFail: '绑定失败',
}

//手机绑定
export const BINDPHONE_LANG = {
  phone: '手机号码',
  sendCode: '发送验证码',
  sendingCode: '正在发送验证码',
  alreadySendingCode: '验证码已发送到你手机',
  sendCodeEmail: '发送验证码到邮箱',
  noReceived: '没有收到？',
  resend: '重新发送',
  sendTime: '发送时间不能小于60秒',
  inputPhone: '请输入手机号',
  phoneNumberErr: '手机号码必须为数字',
  macaoPhoneErr: '请输入正确的8位数手机号码',
  zhPhoneErr: '请输入正确的11位数手机号码',
  phoneErr: '请输入正确的8位数手机号码',
  phoneInputErr: '请输入正确的手机号码',
  inputCode: '请输入收到的验证码',
  codeSend: '验证码已发送',
  bindSuccess: '手机号绑定成功，1秒返后回',
}

// collection 页
export const COLLECTION_LANG = {
  audioNumber: '个音频',
  courseNumber: '节课',
  collectionTab: [{
      name: "讲书",
      code: "talk_book"
    },
    {
      name: "开课",
      code: "course"
    },
    {
      name: "有声书",
      code: "audio"
    },
    {
      name: "电子书",
      code: "ebook"
    },
    {
      name: "视频",
      code: "video"
    }
  ]
}

//historyRecord_audio 页 historyRecord_course 页 historyRecord_ebook 页
export const HISTORYYRECORDAUDIO_LANG = {
  audioBookMsg: '纸质书',
  hearBook: [
    '已听完', '已听'
  ],
  hearCourse: [
    '已看完', '已听', '节课'
  ],
  noComment: '还没有任何内容',
  goToFind: '去发现',
  feedbackErr: '反馈失败！，请稍后再试'
}

//nickName   页
export const NICKNAME_LANG = {
  inputAppellation: '请输入你的新昵称',
  appellation: '昵称',
  appellationMessage: '由2-12个中英文字母、數字 、 “-” 、“_” 組成',
  save: '保存',
  saveSuccess: '保存成功！',
  saveFail: '保存失败！'
}

// personal 页
export const PERSONAL_LANG = {
  user: [
    '头像', '昵称', '邮箱', '手机账号'
  ],
  bingText: [
    '更换绑定', '去绑定'
  ],
  uploadPortrait: '头像上传中',
  uploadPortraitSuccess: '更新头像成功',
  uploadPortraitFail: '更新头像失败',
  uploadPhotoFail: '图片上传错误',
  err: '发生错误',
  getPhotoFail: '获取图片签名失败',
  getUserDataFail: '获取用户信息失败',
  invitationCode: "邀请码",
  member: "至尊会员",
  personalData: "个人资料"
}

//vip 页
export const VIP_LANG = {
  text: [
    '尊敬的知书会员',
    '尽享会员专有优惠，敬请关注!',
    '知书会员',
    '修改会员资料'
  ]
}

// buy 页
export const BUY_LANG = {
  price: '价格',
  myMoney: '我的余额',
  underpayment: '(不足支付)',
  increment: '增值',
  text: '你将购买商品为虚拟内容服务，购买后不支持退订、转让、退换，请在确认购买之前仔细阅读购物条款及细则；购买后可在已购区查看和使用',
  count: '统计',
  confirmPay: '确认支付',
  getGoodsDataFail: '获取销售商品数据失败',
  getUsersAccountDataFail: '获取账户余额失败',
  balanceErr: '余额不足，请增值',
  buyFail: '购买失败！',
  limitedTimeSpike: "限时闪购价",
  packagePrice: "套装价格",
  member: "会员",
  buyingAdvice: {
    title: "购买建议",
    text: "不参加活动，使用优惠券购买更优惠"
  },
  promotion: "该内容正在促销",
  memberCollection: "会员免费领取",
  useBtn: "参加活动",
  bought: "已购买",
  buy: "购买"
}

//buySuccess 页
export const BUYSUCCESS_LANG = {
  text: [
    '购买成功!',
    '订单号',
    '立刻查看',
    '订单详情',
    '产品',
    '实际支付'
  ],
}

//recharge 页
export const RECHARGE_LANG = {
  surplus: '剩余',
  increment: '立刻增值',
  incrementT: '礼品卡充值',
  howToPay: '如何付款',
  dialogText: [
    '您尚未登录',
    '去登录',
    '仅在本设备增值'
  ],
  getIncrement: '正在获取增值结果',
  errPayMes: '支付方式暂时未开放，敬请期待',
  incrementSuccess: '增值成功',
  androidMes: '增值说明：知书币余额仅限 Android 系统消费，无法在其他系统使用。',
  isoMes: '增值说明：知书币余额仅限 iOS 系统消费，无法在其他系统使用。',
  give: "赠",
  native: ["增值记录", "知书币查询"],
  payPalName: "知书币增值",
  text: ["个"],
  input: "请输入充值卡卡号",
  selectPay: {
    0: "知书增值",
    1: "知书币",
    2: "选择支付方式",
    3: "支付宝HK",
    4: "微信支付",
    5: "信用卡支付",
    6: "谷歌支付",
    7: "华为支付",
  }
}

//rechargeList 頁
export const RECHARGELIST_LANG = {
  title: "暂无增值记录",
  text: ["增值：", "知书币", "赠送", "个知书币"]
}

//rechargeSuccess 页
export const RECHARGESUCCESS_LANG = {
  text: [
    '增值成功!',
    '现有知书币',
    '个',
    '确定',
  ],
  record: "增值记录"
}

//comment 组件
export const COMMENTPAGE_LANG = {
  commentTitle: [
    '精选', '全部'
  ],
  inputComment: '写评论',
}

//audioPlayer 组件

export const AUDIOPLAYER_LANG = {
  preview: '试听',
  buyBook: '购书',
  dialogText: [
    '该内容需要购买才可播放',
    '立即购买'
  ],
  playAddressErr: '获取播放地址错误',
  firstContent: '这是第一个内容',
  lastContent: '这是最后一个内容',
  playErr: '播放发生错误'
}

//audioPlayer[Deprecated] 组件

export const AUDIOPLAYERDE_LANG = {
  shwoDialog: [
    '提示', '此音频需要购买才能解锁收听', '立即购买', '取消'
  ],
  shwoDialogEnd: [
    '提示', '此音频需要购买才能解锁收听', '立即购买', '取消'
  ]
}

//audioStopSet 组件

export const AUDIOSTOPSET_LANG = {
  time: '倒计时',
  switch: '关闭',
  listData: [{
      title: "不开启",
      flag: true,
      show: true
    },
    {
      title: "播完当前声音",
      flag: false,
      show: true
    },
    {
      title: "播完2集声音",
      flag: false,
      show: true
    },
    {
      title: "播完3集声音",
      flag: false,
      show: true
    },
    {
      title: "10分钟后",
      flag: false,
      show: true
    },
    {
      title: "20分钟后",
      flag: false,
      show: true
    },
    {
      title: "30分钟后",
      flag: false,
      show: true
    }
  ]
}

// dialog 组件

export const DIAlOG_LANG = {
  listText: [
    '未登录状态下增值会有以下限制：',
    '1.增值知书币及购买记录无法转移到其他帐号，仅限本设备可用',
    '2.APP卸载后增值知书币无法找回'
  ]
}

//relBook 页
export const RELBOOK_LANG = {
  relBook: '相关推荐',
  text: ['视频', '纸本书', '电子书'],
  changeCode: ["讲书", "开课", "有声书", "电子书", "视频", "查看详情"],
  err: "获取播放地址失败",
  showToast: "该服务由超阅网提供",
  showToast1: "该服务由一本提供",
  showToast2: "即将前往外部链接",
}

// searchBlock 组件
export const SEARCHBLOCK_LANG = {
  text: '查看更多搜索结果'
}

// about 页

export const ABOUT_LANG = {
  text: {
    0: '知书 · 关于',
    1: '「知书」是全港第一个以「听」为主的阅读移动平台，集读、听、看、学于一身。「知书」旨在满足当下都市人对阅读「快速」、「有趣」、「品味」的需求，随时随地为他们提供精准的知识服务。读者可根据自己不同的时间状态来选择知识的媒体；除了传统的阅读，还可以听书、听课程,每个人可根据各自的习惯来选择阅读模式，无缝隙地让阅读走入大家的生活。内容主要是以音频、视频、文字等呈现阅读的多种场景，当中以「听书」为核心功能。',
    2: '知书版本：',
  }
}

//advertising 页

export const ADVERTISING_LANG = {
  text: {
    0: '知书 · 广告合作',
    1: '以集读、听、看、学于一身的「知书」，连结百多万香港人的知识服务平台。为配合人们阅读习惯的转变，我们正在探索新形态的图书出版和流通模式。',
    2: '年龄在18-45岁之间的人群是主要使用新媒体的受众，同时也是需要不断自我增值及学习的阶段，「知书」是本港首个知识服务类平台，利用丰富的作者资源和内容优势，透过多样态的知识内容，提供快速、实用、有趣的资讯，配合实用轻巧的课程为主打，同时利用当下热点作为内容包装，引起年青一代关注，大受读者及广告客户欢迎。',
    3: '网上媒体广告效益有增无减，手机应用程式不受时间及地域限制，令读者能更便捷地接收知识，「知书」为广告客户提供个性化宣传方案，透过一站式及多元化的营销方案，帮助客户寻求新潜在客户，以扩大客户基础。'
  }
}

//feedBack 页

export const FEEDBACK_LANG = {
  opinion: '请提出您宝贵的意见：',
  youPhoneOrEMail: '您的邮箱或者手机号：',
  inputOpinion: '请填写反馈内容',
  inputContactMode: '请填写联系方式',
  confirmErr: '操作频繁，请两分钟后再提交',
  confirmSuccess: '反馈成功',
  confirmFail: '反馈失败！请稍后再试'
}

//setting 页

export const SETTING_LANG = {
  list: {
    0: '用户ID：',
    1: '意见反馈',
    2: '应用评分',
    3: '语言设置',
    4: '关于',
    5: '帮助中心',
    6: '广告合作',
    7: '隐私政策',
    8: '知书服务使用条款',
    9: '清除本地数据缓存',
    10: '退出登录',
    11: '开发者工具',
    12: ["消息推送设置(点击开启)", "消息推送设置(点击关闭)"],
    13: '切换至繁体',
    14: '切换至简体',
  },
  dataDelect: '本地缓存数据已全部清除！'
}


//help 页

export const HELP_LANG = {
  text: {
    0: '知书 · 帮助中心',
    1: '- 帐号问题 ',
    2: '1. 如何注册并登录知书APP？',
    3: '目前注册知书APP需以有效的邮箱、电话或第三方平台作为绑定。成功注册后，在每次登录时可选择「邮箱验证码」或「账号密码」两种方式进行身份验证。',
    4: '2. 如何在知书APP绑定（取消绑定）邮箱？',
    5: '在APP右下角「我」，右上角齿轮「设置」，点击「账号绑定设置」即可进行设定。',
    6: '3. 可否注销我的账户?',
    7: '目前知书APP没有注销功能，如确实需要注销全部个人资料，请与我们的客户服务人员联系。nowbookinfo@suep.com',
    8: '4. 如何更改密码？',
    9: '在个人设置页面，点击「更改密码」即可。过程需要提供邮箱验证码作为身份验证。',
    10: '5. 忘记密码怎么办？',
    11: '如已登录请先登出账号，在登录介面下方点击「找回密码」即可。如忘记注册所用的邮箱地址，请与我们的客户服务人员联系。',
    12: '- 增值问题',
    13: '1. 为什么必须增值？',
    14: '知书APP内的付费内容，均为自由定价型虚拟商品，虚拟商品必须通过增值完成消费。',
    15: '2. 知书币可用于购买哪些商品？',
    16: '知书币余额可用于购买APP内虚拟商品，如讲书、课程、有声书、电子书等。',
    17: '3. 知书币可以退款或提现吗？',
    18: '知书币余额为增值后用户虚拟商品消费的虚拟币，增值后的余额不会过期，但无法提现或转增。',
    19: '在支付前请仔细核对支付账号及支付金额，以便后续顺利使用。',
    20: '4. 增值后为何没有即时到账？',
    21: '知书APP的增值服务由第三方支付平台完成，如果存在增值问题，请与我们的客服联系。客户服务电邮：nowbookinfo@suep.com',
    22: '请提供支付记录、凭证之截图，并提供正确的客户注册邮箱地址。查明核实后，我们会尽快助你完成增值并处理问题',
    23: '- 购买问题',
    24: '1. 知书APP有什么商品？',
    25: '知书APP持续制作大量与书有关的精美音频、课程、电子书等内容，建议你经常打开APP并在「发现」页探索最新的优质内容。',
    26: '2. 知书APP会员如何在线下实体书店享受折扣优惠？',
    27: '知书会员于香港全线三联书店、中华书局、商务印书馆实体店享有购书优惠。于收银台结账时，只需打开知书APP，登录后于「发现」页点击右上角的「会员卡」图标，会显示二维码。将此二维码提供给收银工作人员即可享受优惠。',
    28: '. 虚拟商品是否存在使用期限？',
    29: '知书APP内的全部虚拟内容无使用期限。',
    30: '4. 我的知书币是否会过期？',
    31: '知书币为虚拟币，增值后的余额不会过期，但无法提现或转赠他人。',
    32: '5. 购买了虚拟商品，可否退换？',
    33: '知书APP内的所有付费内容，均为自由定价型虚拟商品，不支持退换。',
    34: '在购买、支付时，请务必清楚购买内容及使用期限。如遇到特殊异常问题无需紧张，请与我们的客户服务人员联系，我们会第一时间为你提供帮助。',
    35: '6. 购买的内容无法查看、使用，怎么办？',
    36: '遇到使用异常，请先确认网络是否通畅、连接正常。',
    37: '如无法解决问题，请保留错误提示或出现异常的页面的截图，并与我们的客户服务人员联系，我们会尽快为你处理。',
    38: '- 页面问题',
    39: '1. 网络正常，为何一些页面却刷新缓慢甚至无法打开？',
    40: '即使在网络良好的情况下，APP服务器的连接也会有可能存在短暂的断开，因此会导致页面无法正常显示。',
    41: '建议可以退出当前页面，或彻底关闭APP并再次打开。如仍然无法打开，请检查数据网络、WIFI服务的状态是否正常。',
    42: '2. 查看内容时，图片文字显示异常？',
    43: '与上述情况类似，显示异常可能与网络连接有关。请退出当前页面或关闭APP，并重新进入尝试。',
    44: '3. 异常问题持续，如何解决？',
    45: '请保留出问题的页面或错误提示，并与我们的客户服务人员联系。',
    46: '- 音频问题',
    47: '1. 播放时出现异常停顿，加载时间过长？',
    48: '音频加载与手机内存，网络情况都有关係。如果多次出现加载问题，请尝试退出APP并重新打开。或尝试在手机设置中，清理知书APP的缓存档。',
    49: '2. 为何点击播放却没有反应？',
    50: '请先确定当前网络连接正常，或尝试退出当前页面，并重新进入点击。如问题仍然存在，请保留当前页面截图并与客户服务人员联系。',
    51: '3. 知书APP的内容可以下载吗？',
    52: '知书APP的全部虚拟内容受版权保护，因此所有声音档案不支持下载内容，只有电子书可以离线下载，但不可下载到APP以外的地方。在播放页面，你可以点击下载按钮对有兴趣的内容进行「缓存」，以便在网络不理想的情况下流畅阅读。',
  }
}


// policy 页

export const POLICY_LANG = {
  title: "知书隐私条款",
  text: {
    1: '知书 · 隐私政策',
    2: '生效日期： 2015年7月1日',
    3: '请注意我们可能对此声明作出更正修改而不作预先通知。请阁下定时查阅',
    4: '在本私隐声明内，「个人资料」指任何与以下有关的资料：',
    5: '(甲) 直接或间接与一名在世的个人有关的；',
    6: '(乙) 可以切实地从该资料直接或间接地确定有关的个人的身分；',
    7: '(丙) 该资料的存在形式令予以查阅及处理均是切实可行的。',
    8: '1. 私隐政策',
    9: '1.1 服务承诺',
    10: '为致力保障个人资料的私隐权，本公司确保在收集、使用、保留、转移及查阅个人资料方面的政策及常规，均符合香港法例第486章个人资料（私隐）条例的规定（「条例」）。本公司只会根据条例及此私隐声明收集、使用或披露个人资料。',
    11: '1.1.1 Cookies',
    12: '在使用我们APP（包括流动服务）之时，除非另有说明，否则本公司只会记下阁下曾经到访，而不会收集任何可辨识个人身份的资料（即关于阁下及可用于辨识阁下身份的资料）。我们的APP任何部分所使用的Cookies（如有），并非用于收集可辨识个人身份的资料。Cookies是细小的电脑档案，可储存于上网人士的电脑内，用于获取配置资料以及分析上网人士的浏览习惯。Cookies可免除阁下每次浏览APP时重新登记的麻烦，并通常用于追踪阁下喜欢选择的网页主题。阁下如不希望接受Cookies，可以修改有关互联网选项或阁下电脑系统的浏览选项，但阁下可能因此无法使用或启动本APP的若干功能。',
    13: '1.1.2 收集个人资料',
    14: '阁下或须不时提供可辨识阁下个人资料，包括但不限于阁下的姓名、性别、出生日期、国籍、电话号码、传真号码、邮寄地址、电邮地址、信用卡资料、银行户口号码、教育程度、职业、家庭收入、个人收入、婚姻状况及兴趣 （「个人资料」）。 ',
    15: '如阁下拒绝提供有关资料，便可能无法登录APP的部分内容，并可能令本公司无法处理阁下的申请或要求，因而令阁下无法达到浏览APP的目的。如阁下未满十八岁，必须先得到家长或监护人的同意，方可向本公司提供任何个人资料。',
    16: '1.1.3 收集个人资料的用途',
    17: '本公司从阁下收集的个人资料会因收集资料的情况而定，阁下的个人资料大概会用于：',
    18: '(甲) 阁下提供给本公司的用途；',
    19: '(乙) 与阁下提供给本公司直接有关的用途；',
    20: '(丙) 任何阁下已同意的用途。',
    21: '1.1.4 个人资料的保存',
    22: '阁下与本公司进行业务往来之时，本公司将保存阁下的网上交易纪录以作审核之用。本公司的一般政策是将有关资料保存一段合理时间。按照我们的内部政策，这些纪录之后会从我们的系统中被删除。 ',
    23: '1.1.5 查阅及更正资料',
    24: '根据有关条例，阁下有权：',
    25: '1.1.5.1 查核本公司是否持有阁下任何个人资料；',
    26: '1.1.5.2 查阅本公司持有阁下的个人资料；',
    27: '1.1.5.3 要求本公司更正任何不正确的个人资料；',
    28: '1.1.5.4 确定本公司就个人资料（不时）採取的政策及常规，以及本公司持有的个人资料之类别。',
    29: '如欲查阅或更正个人资料，或索取有关政策和常规以及本公司所持个人资料类别的资料，请以下列途径提出要求：',
    30: '邮寄：香港鲗鱼涌英皇道1065号东达中心1304室「知书」客户服务部主管 收',
    31: '电邮： nowbookinfo@suep.com',
    32: '星期一至五 早上9时至晚上6时; 星期六、日及公众假期休息',
    33: '我们会于收到你的要求后40天内作出回应。本公司对阁下每次成功查阅个人资料，可酌收不时厘定之合理费用。然而，倘阁下确实是为作出合理更正而查阅个人资料，则将获豁免有关费用。惟条例赋予某些豁免条款，可能适用于查阅及更改个人资料的申请。本公司亦可能会要求阁下亲身提供身份证明，方可申请查阅或更改阁下的个人资料。',
    34: '1.1.6 保安',
    35: '本公司会采取所有实际可行的步骤，以保障阁下的个人资料，免受未经授权人士查阅、处理、删除、损毁或使用有关资料。',
    36: '为保证个人资料的准确性、同时避免未经授权取用个人资料和确保个人资料的正确使用，我们实施了适当的实体、技术、管理措施防范和保障我们所收集的个人资料。',
    37: '为进一步保障特定个人资料，阁下须输入阁下的个人用户名称和密码以进入阁下的「知书会员」帐户。',
    38: '2. 个人资料收集声明',
    39: '阁下作为知书及/或我们的APP的浏览者或会员或顾客，在向本公司申请及/或继续使用本公司服务及／或产品时，可能需要向本公司提供阁下的个人资料。倘有关个人资料并不完整或不正确，本公司可能无法向阁下提供或继续提供有关服务。',
    40: '本公司时刻将阁下的个人资料保密处理。本公司有关收集、使用、保存、披露、转移、保密及查阅个人资料的政策及常规，均符合条例规定，并已载于本私隐声明内。',
    41: '2.1 使用及保存',
    42: '本公司可使用及保存你提供的个人资料，以配合以下用途和阁下与本公司可能同意或法律不时要求的其他用途：',
    43: '2.1.1 处理阁下的会员申请；',
    44: '2.1.3 在阁下同意的情况下，使用阁下的个人资料（包括：姓名、性别、出生日期、国籍、电话号码、传真号码、住址、电邮地址、教育程度、职业、婚姻状况、兴趣、最喜欢的活动和购买行为） 推销、推广及客户管理我们、我们的联营公司、合作伙伴之服务及/或产品。我们会以直销电话、SMS、MMS、电邮、电子讯息、跨平台通讯应用程式（如：手机通讯应用）、手机应用程式、传真﹑邮件、社交媒体等方式向阁下提供有关推广资料;',
    45: '2.1.4 服务的正常管理、运作及保养;',
    46: '2.1.5 设计我们、我们的APP及联营公司供阁下使用而提供的新服务，或改善现有服务;',
    47: '2.1.6 调查投诉、备受怀疑的可疑交易及研究服务改善措施;',
    48: '2.1.7 防止及侦测罪行;',
    49: '2.1.8 根据法例作出披露。',
    50: '2.2 披露及转移',
    51: '在收集阁下的个人资料之前，本公司会在相关的个人资料收集声明中通知阁下有关资料将会向第三者披露。阁下的个人资料大概会用于：',
    52: '(甲) 阁下提供给本公司的用途；',
    53: '(乙) 与阁下提供给本公司直接有关的用途；',
    54: '(丙) 任何阁下已同意的用途。',
    55: '我们可向（不论在香港或海外）下列各方披露及转移阁下的个人资料，并可就以上目的使用、披露、处理或保存阁下的个人资料：',
    56: '2.2.1 我们的代理及承办商（包括资讯技术、网络、客户服务、销售代理及承办商）、任何电讯公司及服务供应商就提供有关服务；',
    57: '2.2.2 银行、财务机构及信贷供应商；',
    58: '2.2.3 追收欠款公司、信用调查机构及保安代理；',
    59: '2.2.4 规管当局、执法机构及法院；',
    60: '2.2.5 我们的专业顾问；',
    61: '2.2.6 任何实际或建议承让或受让我们与阁下相关权利的承让人或受让人。',
    62: '经阁下同意，本公司可能会以其他方式使用及披露阁下的个人资料。除非在特殊情况下，本公司可能需要按法律要求或批准的情况下，披露有关的个人资料，如提供予执法机构或阻止严重威胁公众安全的事宜。',
    63: '2.3 直接促销',
    64: '本公司会用收集所得的个人资料，向阁下传送宣传品及推广优惠或作其他促销的用途，但本公司会遵从条例内有关直接促销的规定。',
    65: '如果本公司打算将阁下的个人资料用作直接促销或转交第三者(不论是否获得金钱或其他财产的回报)作直接促销的用途，则本公司会于收集阁下的个人资料之前，在相关的个人资料收集声明中通知阁下，本公司会向阁下提供拒绝接受直接促销的机会。如若阁下不欲接收有关直接促销通讯或资料，请登录知书账户，然后在「更改个人资料」的页面取消选取「我同意知书按私隐政策声明使用我的个人资料作直接促销」。',
    66: '假如阁下当时没有拒绝接受直接促销，但及后决定不拟接受直接促销，或不希望我们披露、转移或使用阁下的个人资料作上述直接促销用途，阁下可透过下列途径提出要求：',
    67: '邮寄：香港鰂鱼涌英皇道1065号东达中心1304室「知书」客户服务部主管 收',
    68: '电邮： nowbookinfo@suep.com',
    69: '星期一至五 早上9时至晚上6时; 星期六、日及公众假期休息',
    70: '我们会于收到你的要求后40天内作出相关的资料更新，惟此资料更新将不会影响于更新前本公司将阁下的个人资料用作直接促销或已转交第三者作直接促销用途的任何责任。 阁下必须提供相关申请所要求必须填写的个人资料，否则本公司将无法处理阁下的相关申请。'
  }
}

//userTerms 页
export const USERTERMS_LANG = {
  text: {
    0: '《知书服务使用条款》',
    1: '请您（以下亦称「用户」）仔细阅读本协议全部条款，并确认您已完全了解本协议之规定。如果您对本协议的任何条款表示异议，您可以选择不注册知书用户。当您注册成功，使用知书服务，或在知书上发布任何内容均意味著您完全接受本协议各项条款的约束。',
    2: '一、使用规则',
    3: '1、用户注册成功后，知书将给予每个用户一个用户帐号及相应的密码，该使用者帐号和密码由使用者负责保管；用户应当对以其用户帐号进行的所有活动和事件负法律责任。',
    4: '2、使用者须对在知书的注册资料的真实性、合法性、有效性承担全部责任，使用者不得冒充他人；不得利用他人的名义发布任何资讯；不得恶意使用注册帐号导致其他用户误认，否则知书有权立即停止提供服务，收回其帐号并由用户独自承担由此而产生的一切法律责任。',
    5: '3、用户注册帐号应符合中华人民共和国香港特别行政区法律法规的要求，不得注册侵害他人权益、不符合社会道德规范的用户名，对于知书认为不恰当的用户帐户，知书有权不经通告进行封停。',
    6: '4、使用者直接或通过各类方式间接使用知书服务和资料的行为，都将被视作已无条件接受本协定全部内容；若使用者对本协议的任何条款存在异议，请停止使用知书所提供的全部服务。',
    7: ' 5、知书是一个内容发布、分享、传播及获取的平台，用户通过知书发表的资讯为公开信息，其他第三方均可以通过知书获取使用者发表的资讯，使用者对任何资讯的发表即认可该资讯为公开信息，并单独对此行为承担法律责任；任何使用者不愿被其他第三人获知的资讯都不应该在知书上进行发表。',
    8: '6、使用者承诺不得以任何方式利用知书直接或间接从事违反香港法律以及社会公德的行为，知书有权对违反上述承诺的内容予以删除。',
    9: '7、使用者不得利用知书服务制作、上载、复制、发布、传播或者转载如下内容：',
    10: '（1）违反宪法及基本法所确定的基本原则的；',
    11: '（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；',
    12: '（3）损害国家荣誉和利益的；',
    13: '（4）煽动民族仇恨、民族歧视，破坏民族团结的；',
    14: '（5）破坏国家宗教政策，宣扬邪教和封建迷信的；',
    15: '（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
    16: '（8）侮辱或者诽谤他人，侵害他人合法权益的；',
    17: '（9）含有法律、行政法规禁止的其他内容的资讯。',
    18: '8、知书有权对使用者使用情况进行审查和监督，如用户在使用知书时违反任何上述规定，知书或其授权的人有权要求用户改正或直接採取一切必要的措施（包括但不限于更改或删除使用者张贴的内容、暂停或终止使用者使用知书的权利）以减轻用户不当行为造成的影响。',
    19: '9、用户在知书平台增值的读币应用于消费知书平台上的付费内容，知书不对此提供提现服务。',
    20: '二、知识产权',
    21: '知书是一个内容发布、获取、分享及传播的平台，我们尊重和鼓励使用者创作的内容，认识到保护知识产权对知书生存与发展的重要性，承诺将保护知识产权作为知书运营的基本原则之一。',
    22: '1、 使用者在知书上发表的全部原创内容（包括但不仅限于文章、评论和提问），著作权均归用户本人所有。使用者可授权第三方以任何方式使用，不需要得到知书的同意。',
    23: '2、 知书的文字、图片、音讯、视频等版权均归知书享有或与作者共同享有，未经许可，不得任意转载。',
    24: ' 3、知书提供的网路服务中包含的标识、版面设计、排版方式、文本、图片、图形、音讯、视频等均受著作权、商标权及其它法律保护，未经相关权利人同意，上述内容均不得在任何平台被直接或间接发布、使用、出于发布或使用目的的改写或再发行，或被用于其他任何商业目的。',
    25: '4、为了促进知识的分享和传播，用户将其在知书上发表的全部内容，授予知书免费的、不可撤销的、非独家使用许可，知书有权将该内容用于知书各种形态的产品和服务上，包括但不限于网站、脸书、微信以及发表的应用或其他互联网产品。',
    26: '5、第三方若出于非商业目的，将使用者在知书上发表的内容转载到知书之外的地方，应当在作品的正文开头的显著位置注明原作者姓名（或原作者在知书上使用的帐号名称），给出原始连结，注明「发表于知书」，并不得对作品进行修改演绎。若需要对作品进行修改，或用于商业目的，第三方应当联系使用者获得单独授权，按照使用者规定的方式使用该内容。',
    27: '6、在知书上传或发表的内容，使用者应保证其为著作权人或已取得合法授权，并且该内容不会侵犯任何第三方的合法权益。如果第三方提出关于著作权的异议，知书有权根据实际情况删除相关的内容，且有权追究使用者的法律责任。给知书或任何第三方造成损失的，用户应负责全额赔偿。',
    28: '7、如果任何第三方侵犯了知书用户相关的权利，用户同意授权知书或其指定的代理人代表知书自身或用户对该第三方提出警告、投诉、发起行政执法、诉讼、进行上诉，或谈判和解，并且用户同意在知书认为必要的情况下参与共同维权。',
    29: '8、知书有权但无义务对使用者发佈的内容进行审核，有权根据相关证据结合《侵权责任法》、《资讯网路传播权保护条例》等法律法规对侵权资讯进行处理。',
    30: '三、侵权举报',
    31: '知书作为内容发布和知识服务社区，高度重视自由表达和个人、企业正当权利的平衡。依照法律规定删除违法资讯是知书的法定义务。',
    32: '1、受理范围',
    33: '受理知书平台内侵犯企业或个人合法权益的侵权举报，包括但不限于涉及个人隐私、造谣与诽谤、商业侵权。',
    34: '（1）涉及个人隐私：发布内容中直接涉及身份资讯，如个人姓名、家庭住址、身份证号码、工作单位、私人电话等详细个人隐私；',
    35: '（2）造谣、诽谤：发布内容中指名道姓（包括自然人和企业）的直接谩骂、侮辱、虚构中伤、恶意诽谤等；',
    36: '（3）商业侵权：洩露企业商业机密及其他根据保密协定不能公开讨论的内容。',
    37: ' 2、举报条件',
    38: '使用者在知书发表的内容仅表明其个人的立场和观点，并不代表知书的立场或观点。如果个人或企业发现知书上存在侵犯自身合法权益的内容，可以先尝试与作者取得联系，通过沟通协商解决问题。如您无法联系到作者，或无法通过与作者沟通解决问题，您可通过联系知书平台进行投诉。为了保证问题能够及时有效地处理，请务必提交真实有效、完整清晰的材料，否则投诉将无法受理。您需要向知书提供的投诉材料包括：',
    39: '（1）权利人对涉嫌侵权内容拥有商标权、著作权和/或其他依法可以行使权利的权属证明，权属证明通常是营业执照或组织机构代码证；',
    40: '（2）举报人的身份证明；',
    41: '（3）如果举报人非权利人，请举报人提供代表权利人进行举报的书面授权证明。',
    42: '为确保投诉材料的真实性，在侵权举报中，您还需要签署以下法律声明：',
    43: '我本人为所举报内容的合法权利人，我举报的发布在知书上的内容侵犯了本人相应的合法权益，如果本侵权举报内容不完全属实，本人将承担由此产生的一切法律责任，并承担和赔偿知书因根据投诉人的通知书对相关帐号的处理而造成的任何损失，包括但不限于知书因向被投诉方赔偿而产生的损失及知书名誉、商誉损害等。',
    44: '3、处理流程',
    45: '（1）出于网路平台的监督属性，并非所有申请都必须受理。知书自收到举报的七个工作日内处理完毕并给出回復。处理期间，不提供任何电话、邮件及其他方式的查询服务。',
    46: '（2）出现知书已经删除或处理的内容，但是百度、谷歌等搜寻引擎依然可以搜寻到的现象，是因为百度、谷歌等搜寻引擎自带缓存，此类问题知书无权也无法处理，因此相关申请不予受理。您可以自行联系搜寻引擎服务商进行处理。',
    47: '（3）用户在知书中的商业行为引发的法律纠纷，由交易双方自行处理，与知书无关。',
    48: '四、免责声明',
    49: '1、因骇客行为或用户的保管疏忽导致用户帐号非法使用，知书不承担任何责任。',
    50: '2、知书不对使用者发表的内容或评论的正确性进行保证。',
    51: '3、使用者明确同意其使用知书网路服务所存在的风险及一切后果将完全由用户本人承担，知书对此不承担任何责任。',
    52: '4、使用者在知书发表的内容仅表明其个人的立场和观点，并不代表知书的立场或观点。作为内容的发表者，需自行对所发表内容负责，因所发表内容引发的一切纠纷，由该内容的发表者承担全部法律及连带责任，知书不承担任何法律及连带责任。',
    53: '5、知书不保证网路服务一定能满足使用者的要求，也不保证网路服务不会中断，对网路服务的及时性、安全性、准确性也都不作保证。',
    54: '6、对于因不可抗力或不能控制的原因造成的网路服务中断或其它缺陷，知书不承担任何责任，但将尽力减少因此而给用户造成的损失和影响。',
    55: '五、协议修改',
    56: '1、根据互联网的发展和有关法律、法规及规范性档的变化，或者因业务发展需要，知书有权对本协议的条款作出修改或变更，一旦本协定的内容发生变动，无论通知与否，知书对用户和任何第三人均无需承担任何责任。',
    57: '2、如果不同意知书对本协议相关条款所做的修改，用户有权并应当停止使用知书。如果用户继续使用知书，则视为使用者接受知书对本协议相关条款所做的修改。',
    58: '六、附则',
    59: ' 1、本协议的订立、执行和解释及争议的解决均应适用中华人民共和国香港特别行政区法律。',
    60: '2、如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。',
    61: '3、本协议解释权及修订权归联合电子出版有限公司所有。',
  }
}

//sign 模塊
export const SING_LANG = {
  descri: ['签到礼包', '连续签到天数', '天', '获得礼包', '个', '签到规则', '每位用户连续签到则积分递增，若签到中断，则从新开始计算'],
  singGifts: [
    '签到奖赏',
    '规则说明',
    '1.领取成功后，请到“我的-优惠券”中查看;',
    '2.可在商品中兑换或者商品下单时使用;',
    '3.新客首单优惠券不与其他优惠券迭加;',
    '4.使用优惠券时下单手机号码必须为抢礼包时手机号码;',
    '5.如有其他疑问请质询知书客服。'
  ],
  singPopup: ['签到成功!', '连续签满', '恭喜获得礼包', '簽到禮包'],
  calendar: ['连续签到', '总礼包', '个', '签到日历', '可补签', '签到规则 >'],
  receiveGifts: ['免费', '立刻领取会员大礼包', '立刻领取'],
  coin: "知书币",
  text: ['今日已签',
    '连续签到即可获得知书礼包1份',
    '未启动',
    '签到活动正在筹备中，敬请期待',
    '号',
    '签到可获得知书礼包1份',
    '期间签到，每天可获得知书礼包一份',
    '签到可获得知书礼包一份'
  ],
  lists: {
    0: '1、每天登入知书即视为签到成功；',
    1: '2、每名用户每天只可签到一次；',
    2: '3、每连续登入3天，即可获神秘礼包一份；',
    3: '4、若连续签到中断，则重新计算天数；',
    4: '5、签到情况每月1号重新计算；',
    5: '6、最终解释权归知书所有。'
  }
}

//receiveGifts 页
export const RECEIVEGIFTS_LANG = {
  freeCoupon: "免费券",
  props: {
    btn: {
      default: "立刻领取会员大礼包",
      text: "关闭"
    }
  },
  text: ["免费", "近期暂无礼包，敬请期待！", "立刻领取会员大礼包", '请到"我的"查看', "查看我的礼券", "已领取会员大礼包"],
  popMsg: "领取成功",
}

// getCoupon 页
export const GETCOUPON_LANG = {
  itemsText: "张优惠券",
  btn: "立刻领取优惠券",
  popup: {
    text: "你可以在知书-优惠券查看",
    item: ["免费券", "优惠券"]
  }
}

//shareCoupon 页
export const SHARECOUPON_LANG = {
  domText: ["赠送", "张优惠券"],
  btn: "分享优惠券"
}

//giftPackDetail 页
export const GIFTPACKDETAIL_LANG = {
  text: {
    0: "规则说明",
    1: "1.领取成功后，请到“我的-优惠券”中查看;",
    2: "2.可在商品中兑换或者商品下单时使用;",
    3: "3.新客首单优惠券不与其他优惠券叠加;",
    4: "4.使用优惠券时下单手机号码必须为抢礼包时手机号码;",
    5: "5.如有其他疑问请咨询知书客服。"
  }
}

//coupon available 组件
export const COUPONAVAILABLE_LANG = {
  coupon: "优惠券",
  Nocoupon: "暂无可用优惠券",
  btn: "确认"
}

//coupon button 组件
export const COUPONBUTTON_LANG = {
  btn: "确认",
  errBtn: "重新输入",
  receive: {
    success: "领取成功",
    fail: "领取失败"
  }
}

//coupon details 组件
export const COUPONDETAILS_LANG = {
  userText: "此按钮店员点击",
  instructionsForUse: "使用说明",
  change: "换一换",
  goPage: "去发现页使用",
  bought: "商品已经购买了",
  showToast: [
    "最多选择",
    "个",
    "优惠券信息错误",
    "请选择兑换内容"
  ],
  exchange: {
    success: "恭喜，兑换成功!",
    errText: "抱歉，兑换失败!",
    errMsg: "商品已经购买过",
  },
  use: {
    sucBtn: "返回优惠券页",
    errText: "抱歉，使用失败!",
    isUse: "该券已使用",
    backBtn: "返回优惠券",
  },
  cardDescription: "优惠券详情",
}

//coupon List 组件
export const COUPONLIST_LANG = {
  text: [
    "免费券",
    "没有优惠券"
  ]
}

//coupon Popup 组件
export const COUPONPOPUP_LANG = {
  text: [
    "请到已购页查看",
    "恭喜你，获得一张",
    "免费券",
    "确认领取",
  ],
  errBtn: "重新输入",
  errText: "抱歉，兑换失败!",
  sucText: "恭喜，兑换成功!",
}

//coupon Tab 组件
export const COUPONTAB_LANG = {
  expired: "已过期"
}

// receiveCoupon 页
export const RECEIVECOUPON_LANG = {
  itemsText: "张优惠券",
  btn: "立刻领取优惠券",
  popup: {
    text: "你可以在知书-优惠券查看",
    item: ["免费券", "优惠券"]
  },
  couponType: '现金券',
}

// coupon 页
export const COUPON_LANG = {
  text: "兑换优惠券",
}

// coupon exchange 页
export const COUPONEXCHANGE_LANG = {
  text: [
    "VIP特权会员提供贵宾使用",
    "可免费无限享有知书内任意产品",
    "请输入您的兑换码"
  ],
}

// marketing activityBlock 页
export const ACTIVITYBLOCK_LANG = {
  timeText: {
    start: "距开始剩余",
    end: "距结束剩余"
  },
  endOfActivity: "本次活动已经结束",
  title: "为你精选",
  btn: ["点击查看", "立刻抢购"],
  nullData: '活动即将开始，敬请期待'
}

//marketing block 页
export const MARKETINGBLOCK_LANG = {
  flashSale: "限时闪购",
  qualityRecommendation: "精品推荐",
  chooseForYou: "为你精选",
  clickToView: "点击查看"
}

//marketing detail 页
export const MARKETINGDETAIL_LANG = {
  text: [
    "人购买", "简介"
  ]
}

//marketing salesList 页
export const SALESLIST_LANG = {
  text: [
    "限量精选，火热抢购中",
    "距开始剩余",
    "距结束剩余",
    "本次活动已经结束",
  ],
  flashSale: "限时闪购",
  qualityRecommendation: "精品推荐",
  participate: "我参与了",
  activity: "活动",
  activityJoin: "活动，你也赶紧加入吧",
}

//marketing activityList 页
export const ACTIVITYLIST_LANG = {
  flashSale: "限时闪购",
  qualityRecommendation: "精品推荐",
  participate: "我参与了",
  activity: "活动",
  activityJoin: "活动，你也赶紧加入吧",
  promotion: "促销"
}

//contents 页
export const CONTENTS_LANG = {
  text: [
    "套装组合详情",
    "本电子书",
    "个音频",
    "个视频",
    "本书籍",
  ]
}

//member areaList 页
export const AREALIST_LANG = {
  text: [
    "换一换", "暂无", "内容"
  ],
  btnText: {
    nextBtn: "下一页",
    topBtn: "上一页"
  },
  type: ["有声书", "电子书", "视频", "开课", "讲书"]
}

//member count 页
export const COUNT_LANG = {
  text: [
    "12个月累计金额",
    "费",
    "会员",
    "升级为",
    "续会",
    "如欲继续享受会员优惠,只需在有效期内消费满",
    "便可自动续会",
    "消费记录",
    "会员优惠"
  ]
}

//member opoup count 页
export const MEMBERPOPUP_LANG = {
  text: [
    "领取失败",
    "领取成功",
    "确认失败",
    "确认成功",
  ],
  btnText: ["确定", "关闭"],
}


//member userCard
export const USERCARD_LANG = {
  text: [
    "会员卡号：",
    "费",
    "级为",
    "知书会员",
    "钱读更好的书",
    "登入",
    "立刻注册"
  ]
}

// member vipVardSwiper
export const MEMBERSWIPER_LANG = {
  text: [
    "未开启",
    "会籍有效期：",
    "消费金额",
    "会员等级"
  ]
}

//member welfareNav 頁
export const WELFARENAV_LANG = {
  nav: [
    "专享折扣",
    "专享免费产品",
    "会员礼包"
  ],
  title: "会员福利"
}

//record 頁
export const RECORD_LANG = {
  text: [
    "累计消费金额",
    "知书：",
    "详情",
    "还没有任何消费记录",
    "栏目消费"
  ],
  nav: [{
    name: "知书APP内消费"
  }, {
    name: "门店消费"
  }]
}

//supremeMember 页
export const SUPREMEMEMBER_LANG = {
  text: [
    "至尊会员供贵宾使用",
    "可免费无限享有知书APP内任意产品",
    "请输入您的至尊会员码",
  ],
  btn: [
    "确认"
  ]
}

// disount 頁
export const DISOUNT_LANG = {
  text: [
    "专享优惠",
    "会员级别",
    "全线三联书店、中华书局或商务印书馆门市",
    "精选货品9折优惠",
    "所有产品9折",
    "精选货品8折优惠",
    "所有产品8折",
    "知书App内"
  ]
}

//free_goods 页
export const FREEGOODS_LANG = {
  text: ["专享内容"]
}

//memberArea 頁
export const MEMEBERAREA_LANG = {
  nav: [
    "会员详情",
    "会员卡",
    "优惠券",
    "消费记录"
  ],
  title: [
    "会员免费",
    "会员折扣"
  ]
}


//memberFift 頁
export const MEMBERGIFT_LANG = {
  memberGifts: [
    '会员礼包',
    '规则说明',
    '1、领取成功后，请到「我的—优惠券」中查看;',
    '2、优惠券可在商品中兑换或者商品下单时使用;',
    '3、请于指定日期前使用，过期无效;',
    '4、迎新优惠券不得与其他优惠券同时使用;',
    '5、如有其他疑问，请咨询知书客服;',
    '使用范围：',
    '近期暂无礼包，敬请期待！',
    '立刻领取会员大礼包',
    '立刻领取签到大礼包',
    '领取成功',
    '前往我的优惠券使用',
    '使用説明',
    '本券可用于兑换知书APP上指定的内容',
    '1张免费券只能兑换1个内容',
    '请在有效期内使用，逾期作废',
    '天后过期',
    '领取后',
    '6、活动最终解释权归知书所有。'
  ],
}

////memberInfo 頁
export const MEMBERINFO_LANG = {
  text: ["会籍詳情"]
}

//memberDetails頁
export const MEMBERDETAILS_LANG = {
  text: [
    "会员级别、升降级条件以及续会条件",
    "级别名称",
    "级别条件",
    "注册即成为基本会员",
    "12个月累计消费",
    "自动续会",
    "累计消费",
    "基本会员升级:",
    "基本会员于过去24个月内累积消费$1500-4999,即可自动升级至折扣会员；而累积消费达$5000,即可自动升级至超级会员",
    "折扣会员升级:",
    "折扣会员于过去36个月内累积消费$5000,即可自动升级至超级会员",
    "超级会员及折扣会员只要消费满指定金额，即可自动续会；如未达指定消费金额，将于下个月1号调整会员级别",
    "续会条件",
    "级别名称",
    "级别条件",
    "注册即成为基本会员",
    "续会条件",
    "APP内享有折扣",
    "无",
    "产品",
    "全缐三联书店、中华书店、商务印书舘门市享有折扣",
    "精选产品",
    "",
  ]
}

// news 頁
export const NEWS_LANG = {
  text: [
    "知书",
    "详情",
    "评论回复",
    "暂无消息",
    "个人",
    "优惠资讯与公告",
  ],
  err: '设置失败',
  success: '设置成功',
  popupText: ['请开启推送通知', '以第一时间接收消息推送', '立刻开啓', '是否愿意接收最新消息推送', '确定']
}

//message 頁
export const MESSAGE = {
  text: "请先开启消息推送"
}

// publicize頁
export const PUBLICIZE_LANG = {
  text: ["即将前往外部网站"]
}

//codeCard 页
export const CODECARD_LANG = {
  text: [
    "于门店消费时扫描",
    "QRCode赚取消费积分",
    "消费满指定金额，即享门市折扣优惠",
    "会籍状况",
    "会员优惠"
  ],
  card: "知书会员",
  grade: ['知书会员', '至尊会员']
}

//search
export const SEARCH = {
  text: [
    "暂无内容",
    // "搜寻电子书类别里面的书籍",
    // "搜寻有声书类别里面的专辑",
    // "搜寻讲书类别里面的专辑",
    // "搜寻开课类别里面的专辑",
    // "搜寻视频类别里面的内容",
    // "搜寻专辑或者书籍",
    "搜寻内容"
  ]
}


//androidRecharge 頁
export const ANDRECHARDE_LANG = {
  err: "运行异常"
}


export const UTILS_LANG = {
  lang0: "普通话",
  lang1: "广东话",
  lang2: "英语",
}


// 離線閱讀頁
export const EPUBLOCALLIST_LANG = {
  code: {
    status1: '等待下载',
    status2: '获取下载地址',
    status3: '预下载失败',
    status4: '正在下载',
    status6: '下载失败',
    status8: '文件解压失败',
    status9: '已下载',
    status100: '位置错误',
  },
  dele: '删除',
  retry: '重新下载',
  retryTip: '正在重新下载',
  noUserId: '登入后才能下载',
  noFree: '此电子书已过会员免费期，请购买阅读'
}


//網絡判斷彈窗
export const NETWORKTIPS_LANG = {
  message: '当前无wifi，是否允许使用流量播放',
  confirmText: '总是允许',
  cancelText: '允许本次',
  // utils.js
}


export const down_JS = {
  noParameter: '缺少参数',
  status1: '等待下载',
  status2: '获取下载地址',
  status3: '获取地址失败',
  status5: '下载成功',
  status6: '下载失败，请重新下载',
  status7: '解压中',
  status8: '解压失败，请重新下载',
  status11: '文件已存在下载队列，请重试',
  status12: '所有下载任务完成',
  status100: '未知错误',
}

export const epubLocalList = {
  text: "还没有下载的电子书"
}

export const DISCOUNT_LANG = {
  text: [
    "在知书APP内注册，即可成为知书会员，可享有会员折扣及优惠权益。",
    "会员权益说明",
    "专属会员折扣",
    "注册成为知书会员，购买App内各栏目的内容可不定期享有折扣优惠。",
    "会员免费专区",
    "每月更新。知书会员每月可享受一批指定免费内容阅读或收听。",
    "会员折扣专区",
    "每月更新。知书会员在折扣专区购买产品，可享有不同折扣优惠。",
    "会员礼包",
    "每月可领取价值不等的会员福利礼包，包括内容免费券、现金券、折扣券等。"
  ]
}

export const PALY_LANG = {
  text: ["倍速播放", "播放设置"]
}

export const ALI_LANG = {
  text: {
    0: "你正在使用支付宝进行知书币增值",
    1: "知书币",
    2: "姓 (LastName)",
    3: "名 (FirstName)",
    4: "请输入你的手机号码",
    5: "请输入你的邮箱",
    6: "请输入姓",
    7: "请输入名",
    8: "请输入手机号码",
    9: "请输入邮箱",
    10: "不可为空"
  }
}

export const LOAD_END = {
  text: "已经到底啦"
}



// WEBPACK FOOTER //
// ./src/common/lang/zh.js